// @flow
import { _ } from "extensions/underscore";
import $ from "jquery";
import strings from "common/strings";

import { getDecimalSeparator } from "common/utils";

import { Presenter } from "common/components/table/cells/generic";
import { getCurrencyDecimals, getCurrencyName } from "common/helpers/currency";

export class AmountPresenter extends Presenter {
    itemContent(column, content, rowModel) {
        const currencyAttribute = _.propValue(column, "cellOptions.currency.attribute");
        const negativeFormat = _.propValue(column, "cellOptions.negativeFormat") || "(%v)";
        const skipCurrency = _.propValue(column, "cellOptions.skipCurrency");
        let currencyNotFound = false;
        let currency = _.propValue(rowModel, currencyAttribute);
        
        // eslint-disable-next-line eqeqeq
        if (currency == null) {
            if (currencyAttribute === "currency") {
                // Use currency from the redux state
                currency = this.getCurrentCurrency().currency;
            } else {
                currencyNotFound = true;
            }
        }
        
        const currencyName: string = getCurrencyName(currency);
        // $FlowFixMe: This is a use case where toAlias returns a number, not a string. suppress for now.
        const currencyDecimals: number = getCurrencyDecimals(currency);
        const currencySpanContent: string = currencyNotFound ? strings.notAvailableValueUpper : "%s";
        const currencySpan: string = skipCurrency ? "" : `<span data-toggle='tooltip' data-placement='top' title='${currencyName}' class='currency'>${currencySpanContent}</span>`;
        const exactValue = _.propValue(column, "cellOptions.exactValue") || false;

        // Find desired precision for the number. First attempt to use one in cellOptions.
        // If it's not there then use precision from currency references
        // If it's unknown too then use 2
        let precision = _.propValue(column, "cellOptions.precision");
        if (!_.isNumber(precision)) {
            precision = currencyDecimals || 2;
        }

        let formatted = this.formatAmountWithCurrentCurrency(content, {
            format: {
                pos: `%v ${currencySpan}`,
                neg: `${negativeFormat} ${currencySpan}`,
                zero: `%v ${currencySpan}`
            },
            symbol: currency,
            precision: _.isNumber(_.propValue(column, "cellOptions.precision")) ? _.propValue(column, "cellOptions.precision") : currencyDecimals || 2
        });

        if (exactValue) {
            // We are required to show exact decimals as in the source data
            // Find exact decimals from the source
            const { holder: decimalSeparator } = getDecimalSeparator();
            let exactDecimalsString;
            const exactDecimalsStringMatch = content.toString().match(new RegExp(`^-?[\\d]*\\${decimalSeparator}(\\d*)`));
            if (exactDecimalsStringMatch && exactDecimalsStringMatch.length && exactDecimalsStringMatch[1]) {
                exactDecimalsString = exactDecimalsStringMatch[1];

                // If matched decimal string has the same length as the precision then there is no point to replace
                if (exactDecimalsString.length > precision) {
                    // Find a value that we need to replace
                    formatted = formatted.replace(new RegExp(`([\\d]*\\${decimalSeparator})(\\d*)`), `$1${exactDecimalsString}`);
                }
            }
        }

        return formatted;
    }
    
    // eslint-disable-next-line class-methods-use-this
    additionalValueClassNames(column, content) {
        const classes = [];
        if (content < 0) {
            classes.push("credit");
        }
        return classes;
    }
    
    /**
     * CSV text for content for the amount field
     * @param column
     * @param content
     * @param rowModelData
     * @param rowModel
     * @returns {*}
     */
    getCSVContent(column, content, rowModelData, rowModel) {
        let formatted = this.itemContent(column, content, rowModelData, rowModel);
        
        if (formatted) {
            // Remove span
            const $formatted = $("<div/>", { html: formatted });
            $formatted.find("span").remove();
            formatted = $formatted.html().trim();
            return formatted.replace(/,/g, "").replace("(", "-").replace(")", "");
        }
    }
}
